$('.reviews-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
autoplay: true,
        autoPlaySpeed: 1000,
        autoPlayTimeout: 1000,
        autoplayHoverPause: true,
    responsive:{
        0:{
            items:1,
          stagePadding: 30
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
})
$('.owlproduct').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
  dots:false,
    responsive:{
        0:{
            items:1,
          stagePadding: 20
        },
        600:{
            items:1.2
        },
        1000:{
            items:1
        }
    }
})

$('.product-instagram-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
  autoplay: true,
  autoplayHoverPause: true,
  video:true,
    responsive:{
        0:{
            items:1,
          stagePading:30,
           autoplay: false
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
})
$('.product-testimonial-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
  autoplay: true,
        autoPlaySpeed: 1000,
        autoPlayTimeout: 1000,
        autoplayHoverPause: true,
    responsive:{
        0:{
            items:1,
          stagePadding: 30
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
})

$('.reviews-customer-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
navText: ["<img src='https://cdn.shopify.com/s/files/1/0105/8429/3412/files/lft-ar1.png?v=1672056666'>", "<img src='https://cdn.shopify.com/s/files/1/0105/8429/3412/files/lft-ar2.png?v=1672056680'>"],
    
  responsive:{
        0:{
            items:1,
         stagePadding: 20
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
})
$('.reviews-result-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
navText: ["<img src='https://cdn.shopify.com/s/files/1/0105/8429/3412/files/lft-ar1.png?v=1672056666'>", "<img src='https://cdn.shopify.com/s/files/1/0105/8429/3412/files/lft-ar2.png?v=1672056680'>"],
    responsive:{
        0:{
            items:1,
          stagePadding: 20
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
})
$('.reviews-video-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
navText: ["<img src='https://cdn.shopify.com/s/files/1/0105/8429/3412/files/lft-ar1.png?v=1672056666'>", "<img src='https://cdn.shopify.com/s/files/1/0105/8429/3412/files/lft-ar2.png?v=1672056680'>"],
   dots:false,
  responsive:{
        0:{
            items:1,
          stagePadding: 20
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
})

$('.home-blog-video-carousel').owlCarousel({
   loop: true,
   margin: 10,
   nav: true,
   responsive: {
      0: {
         items: 1,
         nav: true,
        dots:true
      },
      600: {
         items: 1,
         nav: true,
        dots:true
      },
      1000: {
         items: 3,
         nav: true,
        dots:true
      }
   }
})
$('.info_msg').hover(function(){
$(this).find('.desc_info').toggle(); 
});

$('.subscribe_modal').click(function(){
$(this).find('input').prop('checked','checked');
var pricing = $(this).find('input').attr('data-price'); 
var compare = $(this).find('input').attr('data-compare');
var selling = $(this).find('input').attr('data-selling');  
var ProductID = $(this).find('input').val();   
$('.price__container span.price-item.price-item--regular').html(pricing);
$('.compare_cc').html('<del>'+ compare +'</del>');
$('.savings_cc').html('YOU SAVE 15%');  
$('#rc_subscription_idc').val(selling);   
$('.product-price1').html(pricing); 
$('.product-price2').show();
$('.product-price3').show();

  
});

$('.onetime__modal').click(function(){
$(this).find('input').prop('checked','checked');
var pricing2 = $(this).find('input').attr('data-price');   
var ProductID = $(this).find('input').val();   
$('.price__container .price-item--regular').html(pricing2);  
$('.compare_cc').html('');
$('.savings_cc').html(''); 
$('#rc_subscription_idc').val('');   
$('.product-price1').html(pricing2); 
$('.product-price2').hide();
$('.product-price3').hide(); 
});


$('.item_pricing').click(function(){
$('.item_pricing').removeClass('dmc_active');
$(this).addClass('dmc_active');  
});
  
$(document).ready(function(){
  $('.subscribe_modal').click();
	// Add minus icon for collapse element which is open by default
	$(".collapse.show").each(function(){
		$(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
	});
	
	// Toggle plus minus icon on show hide of collapse element
	$(".collapse").on('show.bs.collapse', function(){
		$(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
	}).on('hide.bs.collapse', function(){
		$(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
	});
});

$('.page-product .banner-button').click(function(e){
event.preventDefault();
$('.product-form__submit').click();
});

$(window).scroll(function(){
  if ($(window).scrollTop() >= 1000) {
    $('.fixed_cta').addClass('fixedbtv');
   }
   else {
    $('.fixed_cta').removeClass('fixedbtv');
   }
});
  if (window.matchMedia("(max-width: 767px)").matches)
        {
$('.customamc summary').click();
        }

 if(window.location.href.indexOf("tiktok") > -1) 
            {
              $('.customamc summary').click();
            }

function myFunction(x) {
  x.classList.toggle("change");
  }